import React from 'react';
import EditTableColumn from '../EditTableColumn';
import EditTableColumnGroup from '../EditTableColumnGroup';

export const dataToValue = (editType: any, editOptions: any, record: any, dataIndex: any) => {
  const text = record[dataIndex]
  let showValue = text;
  if (text) {
    if (editType === 'cascader') { // 级联
      const { separator = '/', options: cascaderList } = editOptions;
      showValue = [];
      if (text) {
        const labels = (text || '').split(separator);
        const findValuesByLabels = (options: any, labels: any) => {
          const values: any[] = [];

          function search (nodes: any, labelIndex: any) {
            if (labelIndex >= labels.length) {
              return;
            }

            const currentLabel = labels[labelIndex];

            for (const node of nodes) {
              if (node.label === currentLabel) {
                values.push(node.value);
                search(node.children, labelIndex + 1);
              }
            }
          }

          search(options, 0);

          return values;
        }
        showValue = findValuesByLabels(cascaderList, labels)
      }
    } else if (editType === 'radiogroup') { // 单选组
      const { options = [] } = editOptions;
      showValue = options.find((opt: any) => opt.label === text)?.value || ''
    } else if (editType === 'checkboxgroup') {
      const { separator = ',', options = [] } = editOptions;
      const labels = (text || '').split(separator);
      showValue = [];
      labels.forEach((item: any) => {
        const currentKey = options.find((op: any) => op.label === item)?.value;
        if (currentKey) {
          showValue.push(currentKey)
        }
      });
    } else if (editType === 'reftabletree') {
      showValue = [];
      showValue.push({ refname: text, refpk: text });
    } else if (editType === 'select' && editOptions.mode === 'tags') {
      const { separator = '/' } = editOptions; // 默认分隔符
      const labels = (text || '').split(separator);
      showValue = labels;
    } else {
      showValue = text;
    }
  }
  return showValue;
}

export const normalize = (elements: React.ReactElement[]) => {
  const columns:any[] = [];
  React.Children.forEach(elements, (element: any) => {
    if (!(element && (element.type === EditTableColumn || element.type === EditTableColumnGroup))) return;
    const column = { ...element.props };
    if (element.key) {
      column.key = element.key;
    }
    if (element.type === EditTableColumnGroup) {
      column.children = normalize(column.children);
    }
    columns.push(column);
  });
  return columns;
};

export const haveCommonItems = (array1: any, array2: any) => {
  for (const item of array1) {
    if (array2.includes(item)) {
      return true;
    }
  }
  return false;
}

export const isFunc = (func: any) => {
  return typeof func === 'function';
}

// 内置“编辑”，“删除”， 以及编辑态（“取消”， “保存”，“删除”）按钮

export const getOperationItems = (props) => {
  const { record, index, operationItems, isEdit, saveText, cancelText, editText } = props;
  const itemConfig:any = {};
  const restOperationItems:any = [];
  if (!isFunc(operationItems)) {
    operationItems.forEach(item => {
      if (['cancel', "save", "edit"].includes(item.key)) {
        itemConfig[item.key] = { ...item };
      } else {
        restOperationItems.push(item);
      }
    })
  }
  if (!isEdit) {
    const editOperation = typeof editText === "undefined"
      ? []
      : [{
        ...(itemConfig["edit"] || {}),
        key: "edit",
        text: editText
      }]
    if (isFunc(operationItems)) {
      return operationItems(record, index, isEdit, editOperation);
    } else {
      return [...editOperation, ...restOperationItems];
    }
  }

  const inEditOperation = [
    {
      ...(itemConfig["cancel"] || {}),
      key: "cancel",
      text: cancelText
    },
    {
      ...(itemConfig["save"] || {}),
      key: "save",
      text: saveText
    }

  ];
  if (isFunc(operationItems)) {
    return operationItems(record, index, isEdit, inEditOperation);
  } else {
    return [...inEditOperation, ...restOperationItems];
  }
}
